import {
  useMutation
} from '@tanstack/vue-query'
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query'
import {
  unref
} from 'vue'
import type {
  MaybeRef
} from 'vue'
import type {
  BackendErrorEntity,
  TriggerInspectionExpiredBlockNotificationsBodyDto,
  TriggerInspectionExpiredBlockNotificationsResponseDto
} from '.././types'
import { fetchApiInstance } from '../../fetchApiInstance';
import type { ErrorType, BodyType } from '../../fetchApiInstance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const apiTriggerInspectionExpiredBlockNotifications = (
    triggerInspectionExpiredBlockNotificationsBodyDto: MaybeRef<TriggerInspectionExpiredBlockNotificationsBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      triggerInspectionExpiredBlockNotificationsBodyDto = unref(triggerInspectionExpiredBlockNotificationsBodyDto);
      
      return fetchApiInstance<TriggerInspectionExpiredBlockNotificationsResponseDto>(
      {url: `/inspectionExpiredBlockNotifications/trigger`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: triggerInspectionExpiredBlockNotificationsBodyDto
    },
      options);
    }
  


export const getApiTriggerInspectionExpiredBlockNotificationsMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiTriggerInspectionExpiredBlockNotifications>>, TError,{data: BodyType<TriggerInspectionExpiredBlockNotificationsBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiTriggerInspectionExpiredBlockNotifications>>, TError,{data: BodyType<TriggerInspectionExpiredBlockNotificationsBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiTriggerInspectionExpiredBlockNotifications>>, {data: BodyType<TriggerInspectionExpiredBlockNotificationsBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiTriggerInspectionExpiredBlockNotifications(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiTriggerInspectionExpiredBlockNotificationsMutationResult = NonNullable<Awaited<ReturnType<typeof apiTriggerInspectionExpiredBlockNotifications>>>
    export type ApiTriggerInspectionExpiredBlockNotificationsMutationBody = BodyType<TriggerInspectionExpiredBlockNotificationsBodyDto>
    export type ApiTriggerInspectionExpiredBlockNotificationsMutationError = ErrorType<BackendErrorEntity>

    export const useApiTriggerInspectionExpiredBlockNotifications = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiTriggerInspectionExpiredBlockNotifications>>, TError,{data: BodyType<TriggerInspectionExpiredBlockNotificationsBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiTriggerInspectionExpiredBlockNotifications>>,
        TError,
        {data: BodyType<TriggerInspectionExpiredBlockNotificationsBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiTriggerInspectionExpiredBlockNotificationsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    